var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.formatDate))]),_c('div',{staticClass:"content"},_vm._l((_vm.info.array),function(item){return _c('app-resume-item',{key:item.id,attrs:{"info":item,"type":"record","is-log":""}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }